import IRouteProvider = angular.route.IRouteProvider;

/**
 * Created by toomasp on 3.08.2015.
 */
export class RouteConfig {
    _routes = [];// [{path, components, namespace, proxyModule, lazyModule, noAuth, privilege }]
    _default_route = {template: `<error-404></error-404>`};

    route(route) {
        this._routes.push(route);
    }

    routes(routes) {
        routes.forEach(this.route.bind(this));
    }

    defaultRoute(defRoute) {
        this._default_route = defRoute;
    }

    configure($routeProvider: IRouteProvider, config) {
        $routeProvider.otherwise(this._default_route);
        this._routes.forEach(route => $routeProvider.when(route.path, this.configureRoute(route, config)))
    }

    configureRoute(route, config) {
        return _.extend({
            template: this._componentTemplate(route, config),

            component: route.component,
            proxy: !!route.proxy,
            noAuth: !!route.noAuth,
            privilege: route.privilege,
            namespace: route.namespace || route.component,
            external: !!route.external,
            application: route.application || '',
            environment: route.environment || '',
            resolve: route.resolve
        }, route.routeParams || {})
    }

    _componentTemplate(route, config) {
        let componentTag = this._componentTag(this._toFragment(route, config), config, route.external);

        if (!!route.header) {
            let wrapperTag = `<div>`;

            let headers = $.isArray(route.header) ? route.header : [route.header];
            headers.forEach(header => {
                wrapperTag += this._componentTag(this._toFragment(header, config), config);
            });

            wrapperTag += `${componentTag}</div>`;
            componentTag = wrapperTag
        }

        return componentTag;
    }

    _toFragment(host, config): any {
        if (typeof host == 'string') {
            return {component: host, namespace: host};
        }

        return {
            component: host.component,
            namespace: host.namespace,
            application: (host.application || '').toLowerCase(),
            lazyLoad: !!host.proxyModule ? host.proxyModule : (!!host.lazyModule ? () => `${host.lazyModule}-${config.uiVersion}.min.js` : false)
        }
    }

    _componentTag(fragment, config, addAccessCheck = false) {
        let componentTag = `<${fragment.component} class="${fragment.namespace || fragment.component} ${fragment.application || ''} show-action"></${fragment.component}>`;

        if (addAccessCheck) {
            componentTag = `<div viewport-access>${componentTag}</div>`;
        }

        // wrap in lazy loader if needed
        if (fragment.lazyLoad) {
            let lazyModules = fragment.lazyLoad(config);
            if (angular.isArray(lazyModules)) lazyModules = '[' + lazyModules.map(lm => `'${lm}'`).reduce((all, current) => `${all},${current}`) + ']';
            else lazyModules = `['${lazyModules}']`;

            componentTag = `<div oc-lazy-load="${lazyModules}">${componentTag}</div>`;
        }

        return componentTag;
    }

    routeUrl(component, parameters) {
        if (parameters && Array.isArray(parameters))
            throw new Error('parameters must be an object');

        let matches = [];

        _RT: for (let i = 0; i < this._routes.length; i++) {
            if (this._routes[i].component !== component)
                continue;

            var route = this._routes[i];

            let noParamsInRoute = route.path.indexOf(':') < 0;
            let noParamsInRequest = (!parameters || Object.keys(parameters).length == 0);

            if (!noParamsInRoute && noParamsInRequest)
                continue;

            // route path has no params, but request had params, check for special routes where params are defined in route metadata itself
            if (noParamsInRoute && !noParamsInRequest) {
                if (Object.keys(parameters)
                        .map(key => !!route[key] && route[key] == parameters[key])
                        .reduce((total, current) => total && current)) {
                    matches.push(route.path);
                }
                continue;
            }

            if (noParamsInRoute && noParamsInRequest) {
                matches.push(route.path);
                continue;
            }

            let urlParts = route.path.split('/');
            let url = urlParts[0];

            let urlParameterKeys = [];

            for (let j = 1; j < urlParts.length; j++) {
                if (urlParts[j].indexOf(':') < 0) {
                    url += '/' + urlParts[j];
                } else {
                    let key = urlParts[j].substr(1);
                    if (!parameters[key])
                        continue _RT;
                    url += "/" + parameters[key];
                    urlParameterKeys.push(key);
                }
            }

            if (!Object.keys(parameters)
                    .map(key => urlParameterKeys.indexOf(key) > -1)
                    .reduce((total, current) => total && current))
                continue;

            matches.push(url);
        }

        if (matches.length == 1) return matches[0];

        if (matches.length > 1) {
            let shortestUrlRoute = matches[0];
            let shortestUrlRoutePartCount = shortestUrlRoute.split('/').length;
            for (let i = 1; i < matches.length; i++) {
                let matchPartCount = matches[i].split('/').length;

                if (matchPartCount < shortestUrlRoutePartCount) {
                    shortestUrlRoute = matches[i];
                    shortestUrlRoutePartCount = matchPartCount;
                }
            }

            return shortestUrlRoute;
        }


        throw new Error('no route for components/parameter set: ' + component);
    }
}

export let $RouteConfig = new RouteConfig();
export default $RouteConfig;


// WEBPACK FOOTER //
// ./src/main/ui/core/application/RouteConfig.ts